import { Badge, Box, Text, Tooltip } from '@wix/design-system';
import React from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { ModalsModule } from '../../module/extensions/ModalsExtensions';
import s from './PremiumDomainBadge.module.scss';
import { GemSmall } from '@wix/wix-ui-icons-common/lazy';
import { useIsMobile } from '@wix/core-domain-search';
import { PremiumDomainTooltipContent } from './PremiumDomainTooltipContent';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common/odeditor';
export const PremiumDomainBadge = _ref => {
  let {
    size
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const openInfoModal = () => {
    const {
      infoModal
    } = ModalsModule.internals.domainsSharedModalsController;
    const liStyles = {
      paddingLeft: '28px'
    };
    infoModal.show({
      title: t('domain_search_suite.premium_domains.tooltip.header'),
      content: /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "34px"
      }, /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "12px"
      }, /*#__PURE__*/React.createElement(Text, {
        listStyle: "checkmark",
        size: "small",
        weight: "thin"
      }, /*#__PURE__*/React.createElement("ul", {
        style: {
          margin: 0,
          padding: 0
        }
      }, /*#__PURE__*/React.createElement("li", {
        style: liStyles
      }, t('domain_search_suite.premium_domains.tooltip.bullet_1')), /*#__PURE__*/React.createElement("li", {
        style: liStyles
      }, t('domain_search_suite.premium_domains.tooltip.bullet_2')), /*#__PURE__*/React.createElement("li", {
        style: {
          ...liStyles,
          marginBottom: 0
        }
      }, t('domain_search_suite.premium_domains.tooltip.bullet_3'))))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        secondary: true
      }, t('domain_search_suite.premium_domains.tooltip.footer'))))
    });
  };
  return /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    gap: "2px"
  }, /*#__PURE__*/React.createElement(Badge, {
    size: size ?? 'tiny',
    className: s.premiumDomainBadge,
    prefixIcon: /*#__PURE__*/React.createElement(GemSmall, null),
    uppercase: false
  }, /*#__PURE__*/React.createElement(Text, {
    size: size ?? 'tiny',
    weight: "normal",
    light: true
  }, t('domain_search_suite.premium_domains.badge'))), isMobile ? /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: s.infoIcon,
    "data-hook": "premium-domain-info-icon",
    onClick: openInfoModal
  }) : /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(PremiumDomainTooltipContent, null),
    maxWidth: "400px"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: s.infoIcon
  }))));
};
//# sourceMappingURL=PremiumDomainBadge.js.map